export default "__VITE_ASSET__Bxz15PJb__"